import type { ChatMessage } from "../../types";
import type { ComposerSubmissionAcknowledgement } from "./reconcileRemoteComposerSubmission";

export function canonicalComposerSubmissionAcknowledgements(input: {
  readonly canonicalMessages: readonly ChatMessage[] | undefined;
}): ComposerSubmissionAcknowledgement[] {
  // Replica history can render the staged row before the connected thread owns it.
  // Retiring the fallback from replica evidence creates a blank handoff frame.
  return (
    input.canonicalMessages
      ?.filter((message) => message.role === "user")
      .map((message) => ({
        messageId: String(message.id),
        prompt: message.text,
        occurredAt: message.createdAt,
      })) ?? []
  );
}
